module.exports = __webpack_public_path__ + "img/image52.8df6a903.png";